import { __decorate } from "tslib";
import { EditorDefinition, Model, ModelId } from '@core/shared/model';
let MediaAssetSlotsMapModel = /*#__PURE__*/(() => {
  let MediaAssetSlotsMapModel = class MediaAssetSlotsMapModel extends Model {};
  MediaAssetSlotsMapModel = __decorate([EditorDefinition({}, {
    allowAllExposed: true
  }), ModelId("MediaAssetSlotsMapModel") // auto-generated by generate-model-ids
  ], MediaAssetSlotsMapModel);
  return MediaAssetSlotsMapModel;
})();
export { MediaAssetSlotsMapModel };